<template >
  <div v-loading="showFlag">
    <t-card
      ><div>
        <t-form label-position="right" label-width="100px">
          <!-- <t-row>
            <t-col :span="11">
              <t-form-item label="" class="marginBottom">
                <t-radio-group
                  v-model="outType"
                  size="small"
                  style="margin-right: 5px"
                >
                  <t-radio-button label="1">EXCEL</t-radio-button>
                  <t-radio-button label="2">PDF</t-radio-button>
                </t-radio-group>
              </t-form-item>
            </t-col>
          </t-row> -->

          <!-- 件名 と 納期 -->
          <t-row>
            <t-col :span="11">
              <t-form-item
                :label="$t('resource.estimateInfoReferenceInfo.subject')"
                class="marginBottom"
              >
                <t-input v-model="estimateInfoForm.subject" maxLength="100">
                </t-input>
              </t-form-item>
            </t-col>
            <t-col :span="2">&nbsp;</t-col>
            <t-col :span="11">
              <t-form-item
                :label="$t('resource.estimateInfoReferenceInfo.deliveryDate')"
                class="marginBottom"
              >
                <t-input
                  v-model="estimateInfoForm.deliveryDate"
                  maxLength="100"
                >
                </t-input>
              </t-form-item>
            </t-col>
          </t-row>

          <!-- お支払条件 と 有効期限 -->
          <t-row>
            <t-col :span="11">
              <t-form-item
                :label="$t('resource.estimateInfoReferenceInfo.paymentTerms')"
                class="marginBottom"
              >
                <t-input
                  v-model="estimateInfoForm.paymentTerms"
                  maxLength="100"
                >
                </t-input>
              </t-form-item>
            </t-col>
            <t-col :span="2">&nbsp;</t-col>
            <t-col :span="11">
              <t-form-item
                :label="$t('resource.estimateInfoReferenceInfo.deadline')"
                class="marginBottom"
              >
                <t-input v-model="estimateInfoForm.deadline" maxLength="100">
                </t-input>
              </t-form-item>
            </t-col>
          </t-row>

          <!-- 納入場所 -->
          <t-row>
            <t-col :span="24">
              <t-form-item
                :label="
                  $t(
                    'resource.estimateInfoReferenceInfo.customerReceivingAddress'
                  )
                "
                class="marginBottom"
              >
                <t-input
                  v-model="estimateInfoForm.customerReceivingAddress"
                  maxLength="100"
                >
                </t-input>
              </t-form-item>
            </t-col>
          </t-row>

          <t-row>
            <t-col :span="24">
              <t-form-item
                :label="$t('resource.JP_RECEIVE.REMARKS')"
                class="marginBottom"
              >
                <t-input
                  type="textarea"
                  v-model="estimateInfoForm.bikou"
                  placeholder="備考"
                  class="commonDialog dialog_bikou table_common"
                  maxlength="500"
                  show-word-limit
                >
                </t-input>
              </t-form-item>
            </t-col>
          </t-row>

          <!-- 確定ボタン -->
          <t-row>
            <t-col :span="20">&nbsp;</t-col>
            <t-col :span="4" class="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirmClick()"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div></t-card
    >
  </div>
</template>
<script>
import { t } from "@/locales";
import { STR_EMPTY } from "@/utils/const";

import { GetEstimateInfo } from "@/services/number";
import { Modal } from "@tellus/component";
export default {
  data() {
    return {
      estimateInfoForm: {
        subject: "",
        deliveryDate: "",
        paymentTerms: "",
        deadline: "",
        customerReceivingAddress: "",
        bikou: "",
      },

      outType: "1",

      //カバー層のフラップ false:表示しない
      showFlag: false,
    };
  },
  mounted() {
    this.Init();
  },
  props: {
    nbQuoteNo: {
      Type: String,
      default: STR_EMPTY,
    },
  },

  methods: {
    // 初期化
    Init() {
      this.showFlag = true;

      //見積書情報の取得
      GetEstimateInfo(this.nbQuoteNo)
        .then((res) => {
          this.estimateInfoForm.subject = res.nbQtnName;
          this.estimateInfoForm.deliveryDate = res.nbQtnDueDate;
          this.estimateInfoForm.paymentTerms = res.nbQtnPaymentTerms;
          this.estimateInfoForm.deadline = res.nbQtnDeadline;
          this.estimateInfoForm.customerReceivingAddress =
            res.nbQtnDeliveryLocation;
          this.estimateInfoForm.bikou = res.nbQtnRemarks;
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
      //入力チェック結果
      var inputCheckResult = this.InputCheck();

      //入力チェックは問題がない場合
      if (inputCheckResult) {
        this.estimateInfoForm.outType = this.outType;

        var obj = { key: "ok", value: this.estimateInfoForm };

        this.$emit("ok", obj);
      }
    },

    //入力チェック
    InputCheck() {
      //件名
      if (!this.estimateInfoForm.subject) {
        Modal.showWarning(
          "",
          t("resource.estimateInfoReferenceInfo.subject") +
            t("message.input.hint"),
          { confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM") }
        );
        return false;
      }

      //納期
      if (!this.estimateInfoForm.deliveryDate) {
        Modal.showWarning(
          "",
          t("resource.estimateInfoReferenceInfo.deliveryDate") +
            t("message.input.hint"),
          { confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM") }
        );
        return false;
      }

      //お支払条件
      if (!this.estimateInfoForm.paymentTerms) {
        Modal.showWarning(
          "",
          t("resource.estimateInfoReferenceInfo.paymentTerms") +
            t("message.input.hint"),
          { confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM") }
        );
        return false;
      }

      //有効期限
      if (!this.estimateInfoForm.deadline) {
        Modal.showWarning(
          "",
          t("resource.estimateInfoReferenceInfo.deadline") +
            t("message.input.hint"),
          { confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM") }
        );
        return false;
      }

      //納入場所
      if (!this.estimateInfoForm.customerReceivingAddress) {
        Modal.showWarning(
          "",
          t("resource.estimateInfoReferenceInfo.customerReceivingAddress") +
            t("message.input.hint"),
          { confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM") }
        );
        return false;
      }

      return true;
    },
  },
};
</script>

